// Builds the quote-form link and carries the traffic source (utm_source etc.) from the page URL
// into Typeform's hidden fields, so the CIK Leads sheet shows where each lead came from.
// Supports both ?utm_source=... and #utm_source=... in the site URL. Remembered for the session.
const FORM = "https://form.typeform.com/to/gUb3QowC";
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "ref"];

function readParams() {
  try {
    const out = {};
    const take = (s) => {
      new URLSearchParams(s.replace(/^[?#]/, "")).forEach((v, k) => { if (KEYS.includes(k) && v) out[k] = v; });
    };
    take(window.location.search); take(window.location.hash);
    if (Object.keys(out).length) sessionStorage.setItem("cik_utm", JSON.stringify(out));
    return Object.keys(out).length ? out : JSON.parse(sessionStorage.getItem("cik_utm") || "{}");
  } catch (e) { return {}; }
}

// The traffic source as Typeform hidden fields, for the form embedded on the page.
export function quoteHiddenFields() {
  const p = readParams();
  if (!Object.keys(p).length) {
    try { if (document.referrer && !document.referrer.includes("castironkitchen")) p.ref = new URL(document.referrer).hostname; } catch (e) {}
  }
  return p;
}

export function quoteUrl() {
  const q = Object.entries(quoteHiddenFields()).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
  return q ? `${FORM}#${q}` : FORM;
}
